import {useLayoutEffect} from 'react';

const useScrollToTopOnUpdate = (ref: React.MutableRefObject<any>, isLoading?: boolean) => {
  useLayoutEffect(() => {
    ref.current.scrollTop = 0;
  }, [isLoading]);
};
export default useScrollToTopOnUpdate;
